import React from "react";

/**
 * Recruvo Group brand mark.
 * A monogram "R" with an upward chevron accent — signaling upward mobility.
 * Two variants: dark (navy background with gold R) and light (gold background with navy R).
 */
export default function Logo({ size = 40, variant = "dark", className = "" }) {
  const bg = variant === "dark" ? "#0F172A" : "#D4AF37";
  const fg = variant === "dark" ? "#D4AF37" : "#0F172A";
  const accent = variant === "dark" ? "#D4AF37" : "#0F172A";
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 40 40"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-label="Recruvo Group"
    >
      <rect width="40" height="40" rx="9" fill={bg} />
      {/* Upward chevron accent in top-right */}
      <path
        d="M27 12 L32 12 L32 17"
        stroke={accent}
        strokeWidth="2.2"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      {/* Letter R */}
      <text
        x="50%"
        y="55%"
        textAnchor="middle"
        dominantBaseline="middle"
        fontFamily="Outfit, ui-sans-serif, sans-serif"
        fontWeight="800"
        fontSize="22"
        fill={fg}
        letterSpacing="-1"
      >
        R
      </text>
    </svg>
  );
}
